import { Component, Prop } from 'vue-property-decorator';
import BaseComponent from '../base-component';
import { ApartmentDTO } from '@/model/ApartmentDTO';
import { ImageResourceDTO } from '@/model/ImageResourceDTO';
import { FloorAbbrForTooltip } from '@/enums/FloorAbbrForTooltip';

@Component
export class ApartmentDetailHeadingTitle extends BaseComponent {
	@Prop() apartment: ApartmentDTO;
	@Prop() gallery: ImageResourceDTO[][];

	reactive: boolean = true;	// to make isFavorite reactive at least to a change to this variable
	get city() {
		var result = this.apartment.location.city;
		if (this.apartment.location.cityPart) {
			result += " - " + this.apartment.location.cityPart;
		}

		return result;
	}

	get showBreadcrumbs() {
		return !(this.$route.query.predbezne && this.$route.query.csh);
	}

	get galleryHeight() {
		const mql = window.matchMedia("(min-width: 768px)");
		return mql.matches ? 620 : 500
	}

	showTooltipFloor(floorAbbr: string) {
		return (<any>Object).values(FloorAbbrForTooltip).includes(floorAbbr);
	}

	get isFavoriteProduct() {
		return this.$store.isFavoriteProduct
	}

	isFavorite() {
		return this.$store.isFavoriteProduct = this.$cookiesService.getFavoriteProducts().includes(this.apartment.catalogNumber)
	}

	toggleFavorite(catalogNumber: string, to: boolean) {
		console.log()
		this.$cookiesService.setFavoriteProducts(to ? this.$cookiesService.getFavoriteProducts().concat(catalogNumber) : this.$cookiesService.getFavoriteProducts().filter(p => p != catalogNumber));
		this.reactive = !this.reactive;
		this.$store.isFavoriteProduct = to
	}

	mounted() {
		this.isFavorite();
	}

}

export default ApartmentDetailHeadingTitle;
